import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ColumnState {
  columnName: string;
  roiName: string;
  PatternTextRoi: any;
  HeaderPatternTextRoi: any;
  currentFieldName: any;
}

const initialState: ColumnState = {
  columnName: '',
  roiName: '',
  PatternTextRoi: '',
  HeaderPatternTextRoi: '',
  currentFieldName: ''
};

const columnSlice = createSlice({
  name: 'column',
  initialState,
  reducers: {
    setColumnName(state, action: PayloadAction<string>) {
      state.columnName = action.payload;
    },
    clearColumnName(state) {
      state.columnName = '';
    },
    setRoiName(state, action: PayloadAction<string>) {
      state.roiName = action.payload;
    },
    clearRoiName(state) {
      state.roiName = '';
    },
    setPatternTextRoi(state, action: PayloadAction<string>) {
      state.PatternTextRoi = action.payload;
    },
    clearsetPatternTextRoi(state) {
      state.PatternTextRoi = '';
    },
    setHeaderPatternTextRoi(state, action: PayloadAction<string>) {
      state.HeaderPatternTextRoi = action.payload;
    },
    clearsetHeaderPatternTextRoi(state) {
      state.HeaderPatternTextRoi = '';
    },
    setCurrentFieldName(state, action: PayloadAction<string>) {
      state.currentFieldName = action.payload;
    },
    clearCurrentFieldName(state) {
      state.currentFieldName = '';
    }
  }
});

export const {
  setColumnName,
  clearColumnName,
  setRoiName,
  clearRoiName,
  setPatternTextRoi,
  setHeaderPatternTextRoi,
  setCurrentFieldName,
  clearCurrentFieldName,
  clearsetPatternTextRoi,
  clearsetHeaderPatternTextRoi
} = columnSlice.actions;
export default columnSlice.reducer;
